import { Provider } from '@angular/core';
import { OrderApiOrigin, OrderApiService, provideOrderApiOrigin } from '@isaia/order';
import { OrderService } from './order.service';
import { CheckoutRetailStrategy } from './checkout-retail.strategy';
import { CheckoutWholesaleStrategy } from './checkout-wholesale.strategy';

export function provideOrder(options: OrderApiOrigin): Provider {
  return [provideOrderApiOrigin(options), OrderService, OrderApiService, CheckoutRetailStrategy, CheckoutWholesaleStrategy];
}
